export default __webpack_public_path__ + "static/media/Macro_Blue.c599c54e.mp4";